import React from 'react';
import _ from 'lodash';
import CSSModules from 'react-css-modules';
import styles from './styles.scss';

const DetailGroup = CSSModules(({ organization_code, shops, user }) => {
  const groupTitle = user.organization.code === organization_code ? '直営店' : shops[0].organization_name;
  return (
    <div styleName="group">
      <div styleName="group-name">{groupTitle}</div>
      {shops.map(s => (
        <div styleName="detail-row" key={s.name}>
          <div styleName="title">{s.name}</div>
          <div styleName="count">
            <div>{s.money_count.toLocaleString()}件</div>
            <div>{s.point_count.toLocaleString()}件</div>
          </div>
          <div styleName="amount">
            <div>¥{s.money.toLocaleString()}</div>
            <div>{s.point.toLocaleString()}</div>
          </div>
        </div>
      ))}
    </div>);
}, styles);

const Balance = ({ summary, user }) => {
  const orgCode = user.organization.code;
  const { topup, payment, refund_topup, refund_payment } = summary;
  const topupShops = topup.shops || [];
  const paymentShops = payment.shops || [];
  const refundTopupShops = refund_topup.shops || [];
  const refundPaymentShops = refund_payment.shops || [];
  const groupByOrganizationCode = (shops, code) => {
    const grouped = _.groupBy(shops, 'organization_code');
    return Object.assign({}, _.pick(grouped, [code]), _.omit(grouped, [code]));
  };

  return (
    <div>
      <div styleName="summary">
        <div styleName="charge">
          <div styleName="row">
            <div styleName="title">チャージ計</div>
            <div styleName="count">
              <div><small>マネー</small> {(topup.total_money_count || 0).toLocaleString()}件</div>
              <div><small>ポイント</small> {(topup.total_point_count || 0).toLocaleString()}件</div>
            </div>
            <div styleName="amount">
              <div>¥{(topup.total_money_amount || 0).toLocaleString()}</div>
              <div>{(topup.total_point_amount || 0).toLocaleString()}</div>
            </div>
          </div>
          {_.map(groupByOrganizationCode(topupShops, orgCode), (shops, code) => <DetailGroup key={code} organization_code={code} shops={shops} user={user} />)}
        </div>

        <div styleName="payment">
          <div styleName="row">
            <div styleName="title">支払計</div>
            <div styleName="count">
              <div><small>マネー</small> {(payment.total_money_count || 0).toLocaleString()}件</div>
              <div><small>ポイント</small> {(payment.total_point_count || 0).toLocaleString()}件</div>
            </div>
            <div styleName="amount">
              <div>¥{(payment.total_money_amount || 0).toLocaleString()}</div>
              <div>{(payment.total_point_amount || 0).toLocaleString()}</div>
            </div>
          </div>
          {_.map(groupByOrganizationCode(paymentShops, orgCode), (shops, code) => <DetailGroup key={code} organization_code={code} shops={shops} user={user} />)}
        </div>
      </div>

      <div styleName="summary">
        <div styleName="charge">
          <div styleName="row">
            <div styleName="title">チャージキャンセル計</div>
            <div styleName="count">
              <div><small>マネーキャンセル</small> {(refund_topup.total_money_count || 0).toLocaleString()}件</div>
              <div><small>ポイントキャンセル</small> {(refund_topup.total_point_count || 0).toLocaleString()}件</div>
            </div>
            <div styleName="amount">
              <div>¥{(refund_topup.total_money_amount || 0).toLocaleString()}</div>
              <div>{(refund_topup.total_point_amount || 0).toLocaleString()}</div>
            </div>
          </div>
          {_.map(groupByOrganizationCode(refundTopupShops, orgCode), (shops, code) => <DetailGroup key={code} organization_code={code} shops={shops} user={user} />)}
        </div>

        <div styleName="payment">
          <div styleName="row">
            <div styleName="title">支払キャンセル計</div>
            <div styleName="count">
              <div><small>マネーキャンセル</small> {(refund_payment.total_money_count || 0).toLocaleString()}件</div>
              <div><small>ポイントキャンセル</small> {(refund_payment.total_point_count || 0).toLocaleString()}件</div>
            </div>
            <div styleName="amount">
              <div>¥{(refund_payment.total_money_amount || 0).toLocaleString()}</div>
              <div>{(refund_payment.total_point_amount || 0).toLocaleString()}</div>
            </div>
          </div>
          {_.map(groupByOrganizationCode(refundPaymentShops, orgCode), (shops, code) => <DetailGroup key={code} organization_code={code} shops={shops} user={user} />)}
        </div>
      </div>
    </div>
  );
};

export default CSSModules(Balance, styles);
